import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'
import { stimulus } from '~/init'

export default class RowLinkController extends Controller {
  static values = { url: String }

  navigate () {
    Turbo.visit(this.urlValue)
  }

  stop (event) {
    event.stopPropagation()
    const link = event.target.closest('a[data-turbo-frame]')
    if (link) {
      event.preventDefault()
      const frame = document.querySelector(`turbo-frame#${link.dataset.turboFrame}`)
      if (frame) frame.src = link.href
    }
  }
}

stimulus.register('row-link', RowLinkController)
